import { render } from "./TheAdminResourcesShowModal.vue?vue&type=template&id=a2cc75ec&ts=true"
import script from "./TheAdminResourcesShowModal.vue?vue&type=script&lang=ts"
export * from "./TheAdminResourcesShowModal.vue?vue&type=script&lang=ts"

import "./TheAdminResourcesShowModal.vue?vue&type=style&index=0&id=a2cc75ec&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__